/* Dúvidas "morde a dúvida": põe o cookie desenhado em cada pergunta, solta farelo na mordida e
   conta quantas dúvidas já foram mordidas (o placar da Nina). */
const sec = document.querySelector('[data-mk-faq]');
if (sec) {
  const placar = sec.querySelector('[data-faq-placar]');
  const total = +(placar?.dataset.total || 0);
  const mordidas = new Set();
  const semMov = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* marca de mordida com a beirada de dentes; fica por cima do cookie, na cor do cartão */
  const MORDIDA = '<svg viewBox="0 0 100 100" aria-hidden="true"><g fill="currentColor"><circle cx="50" cy="50" r="30"/><circle cx="44.8" cy="79.5" r="6.2"/><circle cx="34.4" cy="75.6" r="7.5"/><circle cx="26.2" cy="68.3" r="6.2"/><circle cx="21.2" cy="58.4" r="7.5"/><circle cx="20.1" cy="47.4" r="6.2"/><circle cx="23.1" cy="36.7" r="7.5"/><circle cx="29.7" cy="27.9" r="6.2"/><circle cx="39.1" cy="22.0" r="7.5"/><circle cx="50.0" cy="20.0" r="6.2"/></g></svg>';
  const pintaIcones = () => sec.querySelectorAll('[data-icone]').forEach((el) => {
    if (!el.querySelector('svg') && window.mkIcone) el.innerHTML = window.mkIcone(el.dataset.icone) + `<span class="mk-fq__mordida">${MORDIDA}</span>`;
  });
  pintaIcones();
  if (!window.mkIcone) addEventListener('load', pintaIcones, { once: true });

  const farelo = (cookie) => {
    if (semMov) return;
    for (let k = 0; k < 6; k++) {
      const f = document.createElement('span');
      f.className = 'mk-fq__farelo';
      f.style.left = `${80 + Math.random() * 12}%`;
      f.style.top = `${4 + Math.random() * 12}%`;
      f.style.setProperty('--dx', `${10 + Math.random() * 26}px`);
      f.style.setProperty('--dy', `${16 + Math.random() * 30}px`);
      cookie.append(f);
      setTimeout(() => f.remove(), 750);
    }
  };

  /* a Nina morde: segura → morde → mastiga → segura (troca seca de quadro, sem transição) */
  const nina = sec.querySelector('[data-faq-nina]');
  let tempos = [];
  const morde = () => {
    if (!nina || semMov) return;
    tempos.forEach(clearTimeout);
    nina.dataset.q = '2';
    tempos = [setTimeout(() => (nina.dataset.q = '3'), 260), setTimeout(() => (nina.dataset.q = '1'), 1300)];
  };

  sec.querySelectorAll('.mk-fq__item').forEach((d, i) => {
    d.addEventListener('toggle', () => {
      if (!d.open) return;
      farelo(d.querySelector('.mk-fq__cookie'));
      morde();
      mordidas.add(i);
      if (!placar) return;
      placar.innerHTML = mordidas.size >= total
        ? 'Nenhuma dúvida sobrou. <b>Só farelo.</b>'
        : `Você já mordeu <b>${mordidas.size}</b> de ${total} dúvidas`;
    });
  });
}
